// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createStoreReorderReminders = (client) => ({
    /**
     * `POST /store/reorder-reminders/unsubscribe`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreReorderRemindersUnsubscribeCreate
     * @source apps/backend/src/api/store/reorder-reminders/unsubscribe/route.ts
     */
    unsubscribe: (body, query, headers) => client.fetch("/store/reorder-reminders/unsubscribe", { method: "POST", body, query, headers }),
});
//# sourceMappingURL=reorder-reminders.js.map